import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { GeoAltFill, Whatsapp, EnvelopeFill, Facebook, Instagram } from "react-bootstrap-icons";

const Contact = () => {
    return (
        <Container className="my-5">
            <h2 className="text-uppercase text-muted mb-3 fs-6">Contacto</h2>
            <h3 className="fw-bold text-black fs-2">Estamos aquí para ayudarte en todo lo que necesites</h3>
            {/* Redes Sociales */}
            <Row className="justify-content-center my-4">
                {/* Facebook */}
                <Col xs="auto">
                    <button className="social-link mx-2 btn btn-link p-0" onClick={() => alert('Facebook link aquí')}>
                        <Facebook size={40} className="text-primary" />
                    </button>
                </Col>

                {/* Instagram */}
                <Col xs="auto">
                    <button className="social-link mx-2 btn btn-link p-0" onClick={() => alert('Instagram link aquí')}>
                        <Instagram size={40} className="text-danger" />
                    </button>
                </Col>
            </Row>

            {/* Información de Contacto */}
            <Row className="g-4">
                {/* Dirección */}
                <Col md={4}>
                    <Card className="contact-card text-white bg-black h-100 p-4 d-flex align-items-center justify-content-center">
                        <Card.Body className="text-center">
                            <GeoAltFill size={30} className="text-danger mb-2" />
                            <Card.Title className="fw-bold">Dirección</Card.Title>
                            <Card.Text>Pasto - Narino</Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                {/* WhatsApp */}
                <Col md={4}>
                    <Card className="contact-card text-white bg-black h-100 p-4 d-flex align-items-center">
                        <Card.Body className="text-center">
                            <Whatsapp size={30} className="text-danger mb-2" />
                            <Card.Title className="fw-bold">WhatsApp</Card.Title>
                            <Card.Text>+57 310 6820188</Card.Text>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Correo */}
                <Col md={4}>
                    <Card className="contact-card text-white bg-black h-100 p-4 d-flex align-items-center">
                        <Card.Body className="text-center">
                            <EnvelopeFill size={30} className="text-danger mb-2" />
                            <Card.Title className="fw-bold">Correo</Card.Title>
                            <Card.Text>elmao1989@hotmail.com</Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Contact;
